import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'

const Image = ({ image, alt = '', className = '', ...props }) => {
  if (!image) return <></>

  const attrAlt = alt || image.alt || 'image'

  if (image.gatsbyImageData) {
    return (
      <GatsbyImage
        image={image.gatsbyImageData}
        alt={attrAlt}
        className={className}
        {...props}
      />
    )
  } else {
    if (image.url) {
      return (
        <img src={image.url} alt={attrAlt} {...props} className={className} />
      )
    } else {
      return (
        <GatsbyImage
          image={image}
          alt={attrAlt}
          className={className}
          {...props}
        />
      )
    }
  }
}

Image.propTypes = {
  ...GatsbyImage.propTypes,
  alt: PropTypes.string, // Force to be optional
  image: PropTypes.oneOfType([
    PropTypes.shape({
      gatsbyImageData: PropTypes.object
    }),
    PropTypes.shape({
      url: PropTypes.string
    }),
    PropTypes.object
  ])
}

export default Image
